<div class="value" *ngFor="let val of value">{{val}}</div>
<div class="value" *ngIf="!value?.length">-</div>
